const TelegramIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_43666_1356)">
      <path
        d="M34 17C34 26.3925 26.3925 34 17 34C7.6075 34 0 26.3925 0 17C0 7.6075 7.6075 0 17 0C26.3925 0 34 7.6075 34 17Z"
        fill="url(#paint0_linear_43666_1356)"
      />
      <path
        d="M13.8839 24.7917C13.3314 24.7917 13.4305 24.5792 13.2322 24.055L11.6172 18.7283L21.6472 12.4667L22.823 12.7783L21.8455 15.4417L13.8839 24.7917Z"
        fill="#C8DAEA"
      />
      <path
        d="M13.8828 24.7916C14.3078 24.7916 14.492 24.5933 14.7328 24.3666C15.1011 24.0125 19.8328 19.4083 19.8328 19.4083L16.9286 18.7L14.237 20.4L13.8828 24.65V24.7916Z"
        fill="#A9C9DD"
      />
      <path
        d="M14.1671 20.4567L21.0237 25.5142C21.8029 25.9392 22.3696 25.7267 22.5679 24.7917L25.3587 11.645C25.6421 10.4975 24.9196 9.98752 24.1687 10.3275L7.79207 16.6459C6.6729 17.0992 6.68707 17.7225 7.59373 17.9917L11.8012 19.3092L21.5337 13.175C21.9871 12.8917 22.4121 13.0475 22.0721 13.3592L14.1671 20.4567Z"
        fill="url(#paint1_linear_43666_1356)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_43666_1356"
        x1="21.9824"
        y1="5.37342"
        x2="13.4824"
        y2="25.2065"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37AEE2" />
        <stop offset="1" stopColor="#1E96C8" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_43666_1356"
        x1="18.2741"
        y1="17.532"
        x2="21.8158"
        y2="23.1986"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EFF7FC" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_43666_1356">
        <rect width="34" height="34" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default TelegramIcon;
